import React from 'react';
import * as rstm from 'react-simple-tree-menu';

import { DictionaryDeleteModal } from '../../../../pok/components/Dictionary/DictionaryDeleteModal';
import { DictionaryModal } from '../../../../pok/components/Dictionary/DictionaryModal';

interface TreeActionModalPropos {
  variantTree: string;
  variantOperation: 'delete' | 'edit' | 'add';
  item: rstm.TreeMenuItem;
  onAction: (id?: string) => void;
  show?: boolean;
  onClose?: () => void;
}

export const TreeActionModal: React.FC<TreeActionModalPropos> = ({
  variantTree,
  variantOperation,
  item,
  onAction,
  show,
  onClose,
}) => {
  //const auth = useAuth();
  //const notifications = useNotifications();

  // if (!auth.check(Permissions.ConfigurationEdit)) {
  //   notifications.unauthorized();
  //   return <></>;
  // }

  return (
    <>
      {variantTree === 'dictionary' && variantOperation === 'delete' && (
        <DictionaryDeleteModal
          item={item}
          onAction={onAction}
          show={show}
          onClose={onClose}
        />
      )}
      {variantTree === 'dictionary' && variantOperation !== 'delete' && (
        <DictionaryModal
          variant={variantOperation}
          item={item}
          onAction={onAction}
          show={show}
          onClose={onClose}
        />
      )}
    </>
  );
};
